(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 40980:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-page/[slug]",
      function () {
        return __webpack_require__(66796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46412);
/* harmony import */ var _components_ApplicationWeek_LandingPageComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37121);




const LandingPage = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ApplicationWeek_LandingPageComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...props
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (LandingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,5655,3283,992,8219,4459,7463,7121,9774,2888,179], function() { return __webpack_exec__(40980); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);